import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getCountries(languageCode: string): Observable<string[]> {
    const params: { [key: string]: any } = {
      languageCode: languageCode
    };
    return this.http.get<string[]>(`${this.apiUrl}/countries`, {params});
  }

}
